import { Text } from '@optiaxiom/react';

type DateCellProps = {
  date: string;
};

const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const DateCell = ({ date }: DateCellProps) => {
  return <Text fontSize="sm">{formatDate(date)}</Text>;
};
